import * as nodePath from 'path';
import React, { Component } from 'react';
import Sound from 'react-sound';
import { executeEvent } from '../../../360tour/action';
import store from '../../../../store';
import { MdVolumeOff, MdVolumeUp } from 'react-icons/all';

export default class MusicTool extends Component {
    constructor() {
        super();
        this.state = {
            soundOn: false,
        };
    }

    componentDidMount() {
        this.loadAudio.call(this);
    }

    loadAudio() {
        var defaultStatus = window.config.toolbar?.music?.autoplay;
        if (defaultStatus == null) {
            defaultStatus = localStorage.getItem('source-control-on') == 'true';
        }
        if (defaultStatus == null) {
            defaultStatus = this.props.play ?? false;
        }
        this.setState({
            soundOn: defaultStatus,
        });
    }

    toggleSound() {
        var soundStatus = !this.state.soundOn;
        this.setState({
            soundOn: soundStatus,
        });
        localStorage.setItem('source-control-on', soundStatus);
        store.dispatch(
            executeEvent((krpano) => {
                krpano.call(`layer[background_music].togglepause()`);
            }),
        );
    }

    getIconView() {
        if (window.config.toolbar?.music?.icon != null)
            return <img src={`${process.env.PUBLIC_URL}/data/${window.config.toolbar?.music?.icon}`} />;
        return this.state.soundOn ? <MdVolumeUp /> : <MdVolumeOff />;
    }

    getBuildInSound() {
        var toolOption = window.config.toolbar?.music ?? {};
        if (toolOption.autoplay || toolOption.url == null) return;

        var dataUrl = nodePath.join(`${process.env.PUBLIC_URL}/data/`, toolOption.url);
        var playable = this.state.soundOn
            ? Sound.status.PLAYING
            : Sound.status.PAUSED;
        return (
            <Sound
                url={dataUrl}
                playStatus={playable}
                loop={toolOption.loop}
                autoLoad={this.state.soundOn}
                volume={toolOption.volume ?? 20}
            />
        );
    }

    render() {
        var toolOption = window.config.toolbar?.music ?? {};
        if (!toolOption.display) return '';
        return (
            <div className="tool-item" id="tool-music">
                {this.getBuildInSound.call(this)}
                <div
                    className="item-icon"
                    onClick={this.toggleSound.bind(this)}
                >
                    {this.getIconView.call(this)}
                </div>
            </div>
        );
    }
}
